var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}search`,"viewBox":"0 0 12 12"}},[_c('circle',{attrs:{"cx":"5","cy":"5","r":"4.5","fill":"none","stroke":_vm.getColor('main'),"stroke-width":"1"}}),_c('polyline',{attrs:{"points":"8.5 8.5 11.5 11.5","fill":"none","stroke":_vm.getColor('main'),"stroke-width":"1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }